// 1. State Constants & DOM Caching
const VAR_STATES = {
  IN_STOCK: 1,
  SOLD_OUT: 2,
  PREORDER: 3,
  BACKORDER: 4,
  COMING_SOON: 5
};

const DOM = {
  allButtons: null,
  leaveWarehouseBlock: null,
  christmasBlock: null,
  prefix: null,
  msg: null,
  beQuick: null,
  beQuickInline: null,
  variantInput: null
};

function initDOM() {
  // Queries the DOM exactly once to save memory and CPU
  DOM.allButtons = document.querySelectorAll("#main-atc-button, .batc_btn");
  DOM.leaveWarehouseBlock = document.querySelector("#leave-warehouse-block");
  DOM.christmasBlock = document.querySelector("#christmasDeliveryMesg");
  
  if (DOM.leaveWarehouseBlock) {
    DOM.prefix = DOM.leaveWarehouseBlock.querySelector(".prefix");
    DOM.msg = DOM.leaveWarehouseBlock.querySelector(".dispatchmessage");
    DOM.beQuick = DOM.leaveWarehouseBlock.querySelector(".bequick-msg");
    DOM.beQuickInline = DOM.leaveWarehouseBlock.querySelector(".bequick-inline-msg");
  }
  DOM.variantInput = document.querySelector('input[name="id"]');
}

// 2. Helper: Get Variant State
function getVariantAvailabilityState(variant) {
  if (!variant) return null;

  const dispatchDate = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const comingSoon = window.variantMetafields?.[variant.id]?.variant_coming_soon;
  
  const inStock = variant.inventory_quantity > 0;
  const continueSelling = variant.inventory_policy === "continue";

  if (inStock) return VAR_STATES.IN_STOCK;
  
  if (!continueSelling) {
    if (comingSoon == "true" || comingSoon === true) return VAR_STATES.COMING_SOON; 
    return VAR_STATES.SOLD_OUT;
  }
  
  if (dispatchDate) return VAR_STATES.PREORDER;
  return VAR_STATES.BACKORDER;
}

// 3. UI Update: Add To Cart Button
function updateATCButton(variant) {
  if (!DOM.allButtons || DOM.allButtons.length === 0) return;

  const state = getVariantAvailabilityState(variant);

  DOM.allButtons.forEach(btn => {
    const textContainer = btn.querySelector("span") || btn;

    // Reset state
    btn.classList.remove("disabled", "preorder", "oos");
    textContainer.classList.remove("disabled", "preorder");
    btn.disabled = false;

    switch (state) {
      case VAR_STATES.IN_STOCK:
        textContainer.textContent = "Add to Cart";
        break;
      case VAR_STATES.SOLD_OUT:
        btn.disabled = true;
        btn.classList.add("disabled", "oos");
        textContainer.textContent = "Sold Out";
        break;
      case VAR_STATES.PREORDER:
        btn.classList.add("preorder");
        textContainer.textContent = "Pre Order";
        break;
      case VAR_STATES.BACKORDER:
        textContainer.textContent = "Add to Cart";
        break;
      case VAR_STATES.COMING_SOON:
        btn.disabled = true;
        btn.classList.add("disabled");
        textContainer.textContent = "Coming Soon!";
        break;
    }
  });
}

// 4. UI Update: Warehouse & Christmas Block
function updateLeaveWarehouseBlock(variant, product) {
  if (!DOM.leaveWarehouseBlock) return;

  const dispatch = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const state = getVariantAvailabilityState(variant);

  if (state === VAR_STATES.SOLD_OUT || state === VAR_STATES.COMING_SOON) {
    DOM.leaveWarehouseBlock.style.display = "none";
    if (DOM.christmasBlock) DOM.christmasBlock.style.display = "none";
    return;
  }

  DOM.leaveWarehouseBlock.style.display = "flex";

  const hasBeQuick = product?.tags?.includes("change-dispatch-quick");
  if (DOM.beQuick) DOM.beQuick.style.display = hasBeQuick ? "inline" : "none";
  if (DOM.beQuickInline) DOM.beQuickInline.style.display = hasBeQuick ? "inline" : "none";

  if (hasBeQuick) {
    if (DOM.prefix) DOM.prefix.textContent = "";
    if (DOM.msg) DOM.msg.textContent = "";
    if (DOM.christmasBlock) DOM.christmasBlock.style.display = "none";
    return;
  }

  if (state === VAR_STATES.PREORDER) {
    if (DOM.prefix) DOM.prefix.textContent = "Estimated dispatch:";
    if (DOM.msg) DOM.msg.textContent = dispatch;
  } else if (state === VAR_STATES.IN_STOCK || state === VAR_STATES.BACKORDER) {
    if (DOM.prefix) DOM.prefix.textContent = "Estimated delivery:";
    if (DOM.msg) DOM.msg.textContent = "with you in 48 hours";
  }

  if (DOM.christmasBlock) {
    const is48HourMsg = (state === VAR_STATES.IN_STOCK || state === VAR_STATES.BACKORDER);
    if (is48HourMsg) {
      DOM.christmasBlock.innerHTML = "🎄 Arrives before <strong>Christmas</strong>";
      DOM.christmasBlock.style.display = "block";
    } else {
      DOM.christmasBlock.style.display = "none";
    }
  }
}

// 5. Main Orchestrator
function updateProductUI(selectedVariant) {
  const product = window.productData || window.meta?.product;
  updateATCButton(selectedVariant);
  updateLeaveWarehouseBlock(selectedVariant, product);
}

// 6. Load Variant by ID
function loadVariantById(variantId) {
  if (!variantId) return;

  const productData = window.productData || window.meta?.product;
  if (!productData) return;

  const variant = productData.variants.find(
    v => String(v.id) === String(variantId)
  );

  if (variant) {
    updateProductUI(variant);
  }
}

// 7. Initialization & Event Listeners (No Polling)
document.addEventListener("DOMContentLoaded", () => {
  const productData = window.productData || window.meta?.product;
  if (!productData) return;

  // Initialize cached DOM elements
  initDOM();

  let lastProcessedVariantId = 
    DOM.variantInput?.value || 
    new URLSearchParams(window.location.search).get("variant");

  if (!lastProcessedVariantId && productData.variants?.length) {
    lastProcessedVariantId = productData.variants[0].id;
  }

  if (lastProcessedVariantId) {
    setTimeout(() => loadVariantById(lastProcessedVariantId), 0);
  }

  // Intercept Shopify's URL updates instead of running a setInterval timer
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  const handleUrlChange = () => {
    const urlId = new URLSearchParams(window.location.search).get("variant");
    if (urlId && urlId !== lastProcessedVariantId) {
       lastProcessedVariantId = urlId;
       loadVariantById(urlId);
    }
  };

  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    handleUrlChange();
  };
  
  history.replaceState = function(...args) {
    originalReplaceState.apply(this, args);
    handleUrlChange();
  };

  // Catch back/forward browser navigation
  window.addEventListener('popstate', handleUrlChange);

  // Catch standard form changes as a fallback
  document.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'id') {
       const newId = e.target.value;
       if (newId && newId !== lastProcessedVariantId) {
         lastProcessedVariantId = newId;
         loadVariantById(newId);
       }
    }
  });
});